import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { Menu, Phone } from "lucide-react";
import Logo from "../assets/images/logo.png";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import MobilePickupButton from "./MobilePickupButton";
import { setOpenSheet, setOpenBookNow } from "../redux/slices/sheetSlice";
import { User } from "lucide-react";
import whatsApp from "../assets/images/whatsapp.png";

const MobileHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customer.customer);

  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);

  const initials = `${customer?.firstName?.charAt(0) || ""}${
    customer?.lastName?.charAt(0) || ""
  }`.toUpperCase();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 60);
      setPrevScrollPos(currentScrollPos);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  const goToBookNowPage = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "header_book_now_btn_click",
      event_type: "book_now_popup_open",
    });
    dispatch(setOpenBookNow(true));
  };

  return (
    <>
      <div
        id="navbar"
        className={`mobile-header navbar navbar-expand-lg bg-body-tertiary shadow-sm fixed-top transition-all duration-300 ${
          visible ? "top-0" : "top-60"
        }`}
      >
        <div className="mobile-header__inner container-fluid">
          <div className="section-logo mobile-header__logo">
            <Link to="/">
              <img src={Logo} alt="Pressto" width="120" height="28" />
            </Link>
          </div>
          <div className="mobile-header__actions">
            {customer ? (
              <button
                type="button"
                className="mobile-header__icon-btn user-icon"
                onClick={() => navigate("/profile")}
                aria-label="Profile"
              >
                {initials}
              </button>
            ) : (
              <button
                type="button"
                className="mobile-header__icon-btn user-icon"
                onClick={() => dispatch(setOpenSheet(true))}
                aria-label="Sign in"
              >
                <User size={18} />
              </button>
            )}

            <a
              href="tel:1800229199"
              className="mobile-header__icon-btn user-icon"
              aria-label="Call Now"
              onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "header_call_now_btn_click",
                  event_type: "phone_call",
                });
              }}
            >
              <Phone size={18} strokeWidth={2} />
            </a>

            <button
              type="button"
              className="mobile-header__icon-btn user-icon whatsapp-btn"
              aria-label="WhatsApp"
              onClick={() => {
                const phone = "911800229199";
                const message = encodeURIComponent("Let's Start!");
                const url = `https://api.whatsapp.com/send?phone=${phone}&text=${message}`;
                window.open(url, "_blank");
              }}
            >
              <img src={whatsApp} alt="" width={20} height={20} />
            </button>

            <MobilePickupButton onClick={goToBookNowPage} />

            <button
              type="button"
              className="mobile-header__icon-btn menu-icon"
              onClick={() => setIsOpen(true)}
              aria-label="Open menu"
            >
              <Menu size={22} />
            </button>
          </div>
        </div>
      </div>

      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default MobileHeader;
